// Подводка карты к месту мимо листа «Правил».
//
// Лист перетаскивается (`map/floatingPanel.ts`), поэтому отступ берётся с той
// стороны, где лист СТОИТ СЕЙЧАС, а не с левой по умолчанию: отведённый вправо,
// он иначе накрыл бы ровно то место, к которому карту подвели.

export interface Rect { left: number; top: number; width: number; height: number }
export interface Padding { top: number; right: number; bottom: number; left: number }

const EDGE = 40
const GAP = 12

export function sheetPadding(sheet: Rect | null, map: Rect): Padding {
  const pad = { top: EDGE, right: EDGE, bottom: EDGE, left: EDGE }
  if (!sheet) return pad
  const left = sheet.left - map.left
  const right = map.width - (left + sheet.width)
  if (left + sheet.width / 2 < map.width / 2) pad.left = Math.max(EDGE, left + sheet.width + GAP)
  else pad.right = Math.max(EDGE, right + sheet.width + GAP)
  return pad
}
